<template>
  <v-card color="#F5F5F5" class="back pa-4 mt-0 report-card">
    <v-card-title
      >1.13 -
      {{
        $t('Segurança Elétrica agendada x executada - Acumulado')
      }}</v-card-title
    >
    <v-divider></v-divider>
    <v-card-text>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <BarChart
            :chart-data="electricalSafetyScheduleXExceutedChartData"
            :options="options"
          />
        </v-col>
      </v-row>

      <v-simple-table class="main-table" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"></th>
              <th class="text-left"></th>
              <th
                class="text-left"
                v-for="month in data.dataByMonth.map((x) => x.month)"
                :key="month"
              >
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td style="max-width: 60px">
                {{ $t('Segurança elétrica agendada (interna)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.internalElectricalSafetySchedule }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td style="max-width: 60px">
                {{ $t('Segurança elétrica executada (interna)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.internalElectricalSafetyExecuted }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td style="max-width: 60px">
                {{ $t('Segurança elétrica agendada (total)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalElectricalSafetySchedule }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td style="max-width: 60px">
                {{ $t('Segurança elétrica executada (total)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalElectricalSafetyExecuted }}
              </td>
            </tr>
            <tr style="background: #0288d1">
              <td></td>
              <td style="max-width: 60px; color: white !important">
                {{ $t('Porcentagem (total)') }}
              </td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${item.totalPercentage}%` }}
              </td>
            </tr>
            <tr style="background: #bbcf20">
              <td></td>
              <td style="max-width: 60px; color: white !important">
                {{ $t('Porcentagem (interna)') }}
              </td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${item.percentage}%` }}
              </td>
            </tr>
            <!-- <tr style="background: orange">
              <td></td>
              <td style="max-width: 60px; color: white !important">Meta</td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${data.goal}%` }}
              </td>
            </tr> -->
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import BarChart from '../../../../Reports/components/charts/barChart'

export default {
  props: {
    filter: Object,
  },
  components: {
    BarChart,
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      electricalSafetyScheduleXExceuted: undefined,
      page: 1,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      electricalSafetyScheduleXExceutedChartData: {},
      totalElectricalSafetySchedule: [],
      totalElectricalSafetyExecuted: [],
      internalElectricalSafetyExecuted: [],
      internalElectricalSafetySchedule: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      electricalSafetyScheduleXExceutedHeader: [
        {
          text: 'Tipo',
          align: 'center',
          value: 'type',
        },
        {
          text: 'Segurança Elétrica Agendada',
          align: 'center',
          value: 'totalElectricalSafetySchedule',
        },
        {
          text: 'Segurança Elétrica Executada',
          align: 'center',
          value: 'totalElectricalSafetyExecuted',
        },
      ],
      data: {
        dataByMonth: [],
      },
      total: 0,
    }
  },

  async created() {
    this.listelectricalSafetyScheduleXExceuted()
  },

  methods: {
    async listelectricalSafetyScheduleXExceuted() {
      await this.apiService
        .post('bigData/electricalSafetyScheduleExceuted', this.filter)
        .then((response) => {
          this.data = response.content
          this.fillelectricalSafetyScheduleXExceutedChartData()
        })
        .catch((err) => {})
    },

    fillelectricalSafetyScheduleXExceutedChartData() {
      this.electricalSafetyScheduleXExceutedChartData = {
        labels: this.data.dataByMonth.map((x) => x.month),
        datasets: [
          {
            label: 'Execução total',
            data: this.data.dataByMonth.map((x) => x.percentage),
            backgroundColor: '#0288d1',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: 'Execução interna',
            data: this.data.dataByMonth.map((x) => x.percentage),
            backgroundColor: '#bbcf20',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.listelectricalSafetyScheduleXExceuted()
    },
  },
}
</script>
